export default {
  'pages.repository.section.basic': '基础信息',
  'pages.repository.section.gitlab': 'GitLab 同步',
  'pages.repository.section.permissions': '成员权限',
  'pages.repository.create.success': '代码库创建成功',
  'pages.repository.create.failed': '代码库创建失败',
  'pages.repository.update.success': '代码库更新成功',
  'pages.repository.update.failed': '代码库更新失败',
  'pages.repository.gitlab.sync': '同步到 GitLab',
  'pages.repository.gitlab.sync.description':
    '开启后将先创建以项目标识命名的 GitLab 分组，再在分组下创建仓库。仓库地址由系统自动维护。',
  'pages.repository.gitlab.retrySync': '重新同步到 GitLab',
  'pages.repository.gitlab.retrySync.description':
    '当前代码库尚未关联 GitLab 项目。开启后保存，将重新创建或关联项目分组和仓库。',
  'pages.repository.gitlab.creationOrder.title': 'GitLab 创建路径',
  'pages.repository.gitlab.creationOrder.description':
    '保存后将按顺序创建：项目分组（名称和路径均使用项目标识）→ 代码仓库（路径使用代码库标识）。',
  'pages.repository.gitlab.editPermissions.title': '管理 GitLab 仓库成员权限',
  'pages.repository.gitlab.editPermissions.description':
    '保存后将更新由超级软件工厂管理的仓库成员；GitLab 中其他来源的成员不会被移除。',
  'pages.repository.gitlab.pendingIdentifier': '待填写标识',
  'pages.repository.gitlab.memberPermissions.title': '仓库成员',
  'pages.repository.gitlab.memberPermissions.managedOnly':
    '仅管理 SSF 分配成员',
  'pages.repository.gitlab.memberPermissions.description':
    '从当前项目的活跃成员中分配仓库权限。默认按项目角色推荐权限，可按仓库实际职责调整。',
  'pages.repository.gitlab.memberPermissions.empty': '暂未分配仓库成员',
  'pages.repository.gitlab.memberPermissions.noProjectMembers':
    '当前项目没有可分配的活跃成员，请先到项目成员设置中添加成员。',
  'pages.repository.gitlab.memberPermissions.loadFailed':
    'GitLab 成员权限加载失败。为避免误删成员，重新加载成功前无法保存权限。',
  'pages.repository.gitlab.memberPermissions.loadUnavailable':
    '权限数据尚未成功加载，此处不会按空列表处理。请重新加载后再编辑。',
  'pages.repository.gitlab.memberPermissions.retry': '重新加载',
  'pages.repository.gitlab.memberPermissions.tab': 'GitLab 权限',
  'pages.repository.gitlab.memberPermissions.save': '保存权限',
  'pages.repository.gitlab.memberPermissions.saveSuccess':
    'GitLab 权限保存成功',
  'pages.repository.gitlab.memberPermissions.saveFailed': 'GitLab 权限保存失败',
  'pages.repository.gitlab.memberPermissions.consistencyWarning':
    '界面记录可能与 GitLab 实际权限不一致',
  'pages.repository.gitlab.memberPermissions.consistencyWarning.description':
    '请检查失败成员的 GitLab 用户名和目标权限，修正后可重新保存以重试同步。',
  'pages.repository.gitlab.memberPermissions.syncStatus': '同步状态：',
  'pages.repository.gitlab.memberPermissions.syncStatus.synced': '已同步',
  'pages.repository.gitlab.memberPermissions.syncStatus.pending': '待同步',
  'pages.repository.gitlab.memberPermissions.syncStatus.unmapped':
    '未匹配 GitLab 用户',
  'pages.repository.gitlab.memberPermissions.syncStatus.failed': '同步失败',
  'pages.repository.gitlab.memberPermissions.syncStatus.notSynced': '尚未同步',
  'pages.repository.gitlab.memberPermissions.syncError': '失败原因：{error}',
  'pages.repository.gitlab.memberPermissions.effectiveAccessLevel':
    'GitLab 有效权限：{accessLevel}',
  'pages.repository.gitlab.memberPermissions.effectiveAccessLevel.unknown':
    '尚未确认',
  'pages.repository.gitlab.memberPermissions.inheritedAccess':
    '该成员从上级 GitLab 分组继承了权限，仓库级设置无法将其降级或撤销。',
  'pages.repository.gitlab.member': '项目成员',
  'pages.repository.gitlab.member.required': '请选择项目成员',
  'pages.repository.gitlab.member.duplicate': '同一成员不能重复分配',
  'pages.repository.gitlab.member.placeholder': '选择项目成员',
  'pages.repository.gitlab.member.add': '添加成员权限',
  'pages.repository.gitlab.member.remove': '移除成员权限',
  'pages.repository.gitlab.accessLevel': 'GitLab 权限',
  'pages.repository.gitlab.accessLevel.required': '请选择 GitLab 权限',
  'pages.repository.gitlab.accessLevel.10': 'Guest（访客）',
  'pages.repository.gitlab.accessLevel.20': 'Reporter（报告者）',
  'pages.repository.gitlab.accessLevel.30': 'Developer（开发者）',
  'pages.repository.gitlab.accessLevel.40': 'Maintainer（维护者）',
  'pages.repository.gitlab.projectContext.loadFailed':
    '项目标识或成员加载失败，GitLab 权限设置可能不完整。',
  'pages.repository.gitlab.memberSync.unknownError': '未知原因',
  'pages.repository.gitlab.memberSync.partialFailure':
    '{count} 位成员权限同步失败：{details}',
  'pages.repository.gitlab.memberSync.inheritedAccess':
    '{count} 位成员仍从上级 GitLab 分组继承权限，仓库级设置无法降级或撤销：{members}',
  'pages.repository.gitlab.sync.alreadyExists':
    'GitLab 已存在同名仓库，已完成关联',
  'pages.repository.gitlab.sync.success':
    '已同步到 GitLab 项目分组 {groupPath}',
  'pages.repository.gitlab.sync.incomplete': 'GitLab 同步未完成：{reason}',
  'pages.repository.gitlab.sync.createFailed':
    '代码库已创建，但 GitLab 同步失败。可编辑代码库并重新同步。',
};
